

<template>
  <vue-good-table
      mode="remote"
      styleClass="vgt-table table-custom-style striped"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
      :totalRows="totalRecords"
      :isLoading.sync="isLoading"
      :rows="rows"
      :sort-options="{
            enabled: true,
            multipleColumns: true,
            initialSortBy: [{ field: 'created_at', type: 'desc' }],
          }"
      :columns="columns"
      :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
  >
    <template slot="table-row" slot-scope="props">
      <!-- title -->
      <template v-if="props?.column?.field === 'format_tasks'">
              <span>

                <b-badge
                    v-if="props?.row?.overdue"
                    variant="light-danger"
                >
                Overdue
              </b-badge>
                <b-link
                    :href="getPageUrl(props?.row)"
                    target="_blank"
                >
                <div class="font-weight-bold" style="color:black" v-html="breakTitle(props?.row?.title)"></div>
                </b-link>
              </span>

        <div>
          Phase:
          <template v-if="props?.row?.phase?.data?.title">
            <b-badge variant="light-primary">
              {{ props?.row?.phase?.data?.title }}
            </b-badge>
          </template>

          <b-badge v-else variant="light-danger" pill>
            N / A
          </b-badge>
        </div>

        <div>
          <template v-if="props?.row?.word_count">
            Word Count:
            <b-badge variant="light-info">
              {{ props?.row?.word_count }}
            </b-badge>
          </template>
        </div>
      </template>

      <template v-if="props?.column?.field === 'format_member_info'">
              <span v-for="(member, index) in props.row.team.data" :key="index">
                <template v-if="index <= 2">
                  <b-avatar :src="member?.avatar === '' ? '/avatar.svg' : member?.avatar" size="26" style="margin: 1px"
                  />
                </template>
              </span>

        <span v-if="props?.row?.team_count > 0">
                <span v-if="props?.row?.team_count > 3">
                <b-link
                    v-on:click="
                    showAllAddedMemberModal(props?.row?.team?.data)
                  "
                >
                  + {{ props?.row?.team_count - 3 }} more
                </b-link>
              </span>
              </span>
        <b-badge v-else variant="danger">
          N / A
        </b-badge>

      </template>

      <template v-if="props?.column?.field === 'format_phase_info'">
        <b-badge variant="primary">
          {{ props?.row?.phase?.data?.title }}
        </b-badge>
      </template>

      <template v-if="props?.column?.field === 'format_supervisor'">

        <UserCard :user="props?.row?.milestoneTaskBoard?.data?.supervisor?.data" />

      </template>


      <template v-if="props?.column?.field === 'format_date'">
        <b>Deadline: </b>
        <span v-if="props?.row?.deadline">
                {{ formatDate(props?.row?.deadline) }}
              </span>
        <span v-else>
                <b-badge pill variant="light-primary"> N/A </b-badge>
              </span>
        <br />

        <b>Actual Start Date: </b>
        <span v-if="props?.row?.actual_start_date">
                {{ formatDate(props?.row?.actual_start_date) }}
              </span>
        <span v-else>
                <b-badge pill variant="light-primary"> N/A </b-badge>
              </span>
        <br />
        <b>Actual End Date: </b>
        <span v-if="props?.row?.actual_end_date">
                {{ formatDate(props?.row?.actual_end_date) }}
              </span>
        <span v-else>
                <b-badge pill variant="light-primary"> N/A </b-badge>
              </span>
      </template>

      <!-- Column:  Common -->
      <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
    </template>

    <!-- pagination -->
    <template slot="pagination-bottom" slot-scope="props">
      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap"> Showing 1 to </span>
          <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10', '20']"
              class="mx-1"
              @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
          />
          <span class="text-nowrap"> of {{ props.total }} entries </span>
        </div>
        <div>
          <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </template>
  </vue-good-table>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'

import LvColorPicker from 'lightvue/color-picker'
import { milestoneTaskBoardStatusConstants } from '@/helpers/constant/milestoneTaskBoardStatusConstant.js'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant,
} from '@/helpers/constant/milestoneBoardTypeConstant.js'
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import { formatDateRange } from '@/helpers/helpers'
import {
  required, max, size, ext, max_value, min_value,
} from '@validations'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import DashboardActivityLog from '@/views/admin/task-management/Dashboard/Component/DashboardActivityLog.vue'

export default {
  name: 'DataTable',
  components: {
    DashboardActivityLog,
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  props: {
    show: {
      type: Number,
      required: false
    },
    endpoint: {
      type: String,
      required: false
    },
    isSubtask: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSubtask: {
      immediate: true,
      handler(newVal) {
        this.loadItems()
      }
    }
  },
  data() {
    return {

      serverParams: {
        columnFilters: {},
        sort: [
          { field: "created_at", type: "desc" },
        ],
        page: 1,
        perPage: this.show || 3,
      },
      totalRecords: 0,
      isLoading: false,
      rows: [],
      params: [],
      pageLength: this.show || 3,
      columns: [
        {
          label: "Task",
          field: "format_tasks",
          sortable: false,
        },
      ],

    }
  },

  async mounted() {
    try {
      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },

  methods: {
    async loadItems() {
      try {

        this.isLoading = true
        const [globaldata] = await Promise.all([
          this.getGlobalData({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            q: this.searchTerm,
          }),
        ]);

        const data = globaldata?.data?.data;

        const meta = globaldata?.data?.meta;
        this.totalRecords = meta?.pagination?.total;

        this.rows = data;

        this.isLoading = false

      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    async getGlobalData(params) {
      return await this.$api.get(
          this.endpoint,
          {
            params: {
              show: params.show,
              page: params.page,
              sort: params.sort,
              q: params.q
            },
          }
      );
    },

    async getAllMembers() {
      return await this.$api.get(`api/users/all`);
    },

    breakTitle(title) {
      const maxLength = 50;
      if (title && title.length > maxLength) {
        const regex = new RegExp(`(.{1,${maxLength}})`, 'g');
        const truncatedTitle = title.replace(regex, "$1<br>");
        return truncatedTitle;
      }
      return title;
    },

    onShowTaskDetailsPage(board,id, task) {
      this.$router.push({
        name: 'admin-board-task-details',
        params: {
          board,
          id,
          task,
        },
      })
    },

    onShowSubTaskDetailsPage(board, taskId, task, id, subtask) {
      this.$router.push({
        name: 'admin-board-task-subtask-details',
        params: {
          board,
          taskId,
          task,
          id,
          subtask,
        },
      })
    },


    getPageUrl(row) {


      if (!this.isSubtask) {

        return this.getTaskPageUrl(
            row?.milestone_task_board_id,
            row.id,
            row.short_title
        );
      } else {

        return this.getSubTaskPageUrl(
            row?.milestone_task_board_id,
            row?.task?.data?.id,
            row?.task?.data?.short_title,
            row.id,
            row.short_title
        );
      }
    },

    getTaskPageUrl(board,id, task) {
      return this.$router.resolve({ name: "admin-board-task-details", params: {
          board,
          id,
          task,
        }, }).href;
    },

    getSubTaskPageUrl(board, taskId, task, id, subtask) {
      return this.$router.resolve({ name: "admin-board-task-subtask-details", params: {
          board,
          taskId,
          task,
          id,
          subtask,
        } }).href;
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}
</style>
